import { IDesignerProblemsState, LayerProblems } from './IDesignerProblem';
import { PayloadAction } from '@reduxjs/toolkit';

export function setLayerProblemsReducer(
  state: IDesignerProblemsState,
  action: PayloadAction<LayerProblems>,
) {
  state.layers = action.payload;
}
